module.exports = __webpack_public_path__ + "static/media/c8bannerModulF_small.d02ade12.jpg";